"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = require("lodash/isObject");

var _isObject2 = _interopRequireDefault(_isObject);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _hasIn = require("lodash/hasIn");

var _hasIn2 = _interopRequireDefault(_hasIn);

var _has = require("lodash/has");

var _has2 = _interopRequireDefault(_has);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var DataUtils = function DataUtils() {
  var _this = this;

  _classCallCheck(this, DataUtils);

  this.isEmptyObject = function(obj) {
    return (0, _isObject2.default)(obj) && (0, _isEmpty2.default)(obj);
  };

  this.isEmptyArray = function(arr) {
    return (0, _isObject2.default)(arr) && (0, _isEmpty2.default)(arr);
  };

  this.isContentPage = function(dataSet) {
    return (
      !_this.isEmptyObject(dataSet) &&
      (0, _hasIn2.default)(dataSet, "ContentPage")
    );
  };

  this.hasValidComponentsArray = function(dataSet) {
    return (
      _this.isContentPage(dataSet) &&
      (0, _hasIn2.default)(dataSet.ContentPage, "components") &&
      !_this.isEmptyArray(dataSet.ContentPage.components)
    );
  };

  this.validateData = function(dataSet) {
    if (
      _this.isContentPage(dataSet) &&
      _this.hasValidComponentsArray(dataSet)
    ) {
      return true;
    }
    return false;
  };

  this.getComponentDataByResourceType = function(dataSet, resourceType) {
    if (_this.validateData(dataSet) === false) {
      return {};
    }
    return dataSet.ContentPage.components.filter(function(component) {
      return component.resourceType === resourceType;
    })[0];
  };

  this.graphQlDataFailingConditions = function(dataSet) {
    return (
      dataSet === null || dataSet === undefined || _this.isEmptyObject(dataSet)
    );
  };

  this.shouldUseDataOrDefaultProps = function(dataSet, defaultData) {
    if (_this.graphQlDataFailingConditions(dataSet)) {
      return defaultData;
    }
    return dataSet;
  };

  this.renderEmptyString = function(dataProp) {
    if (!dataProp || dataProp === undefined || dataProp === null) {
      return " ";
    }
    return dataProp;
  };

  this.hasNestedProp = function(dataObject, path) {
    var objPathArray = path.split(".").slice(1, path.length - 1);
    return (0, _has2.default)(dataObject, objPathArray);
  };

  this.handleNestedProp = function(dataObject, path) {
    if (_this.hasNestedProp(dataObject, path)) {
      var newPath = path
        .split(".")
        .slice(1, path.length - 1)
        .join(".")
        .toString();
      return (0, _get2.default)(dataObject, newPath, " ");
    }
    return " ";
  };

  this.appendImageTransforms = function(
    imageURL,
    transformImageWidth,
    isBackground
  ) {
    var imageURLWithQueryParams;
    var fileExtension = imageURL ? imageURL.split(".").pop() : "";

    if (fileExtension === "jpg" || fileExtension === "png") {
      imageURLWithQueryParams =
        fileExtension === "jpg"
          ? ""
              .concat(imageURL, "?width=")
              .concat(transformImageWidth, "&auto=webp")
          : ""
              .concat(imageURL, "?width=")
              .concat(transformImageWidth, "&quality=70");
      return isBackground
        ? 'url("'.concat(encodeURI(imageURLWithQueryParams), '")')
        : encodeURI(imageURLWithQueryParams);
    }

    return isBackground ? 'url("'.concat(imageURL, '")') : imageURL;
  };

  this.appendImageOptimization = function (imageURL, transformImageWidth, isBackground, isWebp, quality) {
    var isBackground = (arguments.length > 2 && arguments[2] !== undefined) ? arguments[2] : false;
    var isWebp = (arguments.length > 3 && arguments[3] !== undefined) ? arguments[3] : false;
    var quality = (arguments.length > 4 && arguments[4] !== undefined) ? arguments[4] : false;

    var fileExtension = imageURL ? imageURL.split(".").pop() : "";
    var imageURLWithQueryParams = imageURL;

    if (fileExtension === "jpg" || fileExtension === "jpeg" || fileExtension === "png" || fileExtension === "gif" || fileExtension === "webp") {
      imageURLWithQueryParams += "?width=" + transformImageWidth;
      if (isWebp) imageURLWithQueryParams += "&auto=webp";
      if (quality) imageURLWithQueryParams += ("&quality=" + quality);
      imageURLWithQueryParams = encodeURI(imageURLWithQueryParams);
    }
    if (isBackground) {
      imageURLWithQueryParams = "url(\"" + imageURLWithQueryParam + "\")";
    }
    return (imageURLWithQueryParams);
  };

  this.formatAsMKSPath = function (path) {
    if (typeof path === 'string') {
      return path.charAt(0) === '/' 
        ? path.substring(1).replace(/\//g, ' :: ')
        : path.replace(/\//g, ' :: ');
    }
  }
};

exports.default = DataUtils;
